function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebbde"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebbde"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $79f878b3d1cbd4aa$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"f9fpV":"index.9785fd68.js","cSks4":"sunny.4e1d09f2.png","kcF75":"clear.b227edfd.png","eil8G":"cloudy.441bad3c.png","lGqxp":"cloudy-sun.4f0f6c1f.png","lf5R2":"cloudy-moon.798ac588.png","WvKFx":"rainy-cloud.2173a880.png","hNbIe":"rainy-cloudy-sun.c70f12f2.png","lPOOM":"rainy-cloudy-moon.d1e9d931.png","lGOjp":"snowy-rainy-cloud.42f3e592.png","hNwE3":"snowy-cloudy-moon.57a4d953.png","7xpT8":"snowy-cloud.4bec1424.png","d0NFe":"snowy-rainy-cloudy-moon.37403b25.png","8D38C":"lightning-rainy-cloudy-sun.f965ac38.png","hHLFh":"lightning-snowy-cloud.c01e6dfe.png","iKlo4":"lightning-rainy-cloud.679ec5a0.png","hDjz9":"lightning-cloud.1c163626.png","fPQPF":"windy-sun.e82d7f2f.png","lVhN0":"windy-moon.2f3ab3ea.png","35XQG":"windy-cloudy-sun.9feb41c4.png","hzhTc":"windy-cloudy-moon.20045e69.png","NByNw":"rainy-windy-cloudy-sun.6985e4b9.png","kPZHq":"rainy-windy-cloudy-moon.31305d12.png","huq6v":"lightning-snowy-windy-cloud.3b61dbc7.png","es2sZ":"windy-rainy-cloud.dfee0083.png","24dI6":"details.d983709b.svg"}'));

const $ba30e20475feac5a$export$a9861bd62f48e142 = "b2eb4160b71c4937b0d84320232009";
const $ba30e20475feac5a$export$61abde59b50deb8e = "https://api.weatherapi.com/v1/forecast.json?key=";
const $ba30e20475feac5a$export$196440f71ed9f601 = 10;
const $ba30e20475feac5a$export$1549839c81210d0c = "&days=7&aqi=yes&alerts=no";
const $ba30e20475feac5a$export$e85a0896dd0485b7 = "&days=7&aqi=yes&alerts=no";
const $ba30e20475feac5a$export$b1296de362a35dda = 6;
const $ba30e20475feac5a$export$ff1991c17b0b40f5 = 19;
const $ba30e20475feac5a$export$54ae492174d0c4ef = "&appid=620008ec95722257f62186be3bced52e";
const $ba30e20475feac5a$export$a9b8803b2f2c8a6b = "https://api.openweathermap.org/data/2.5/forecast?q=";
const $ba30e20475feac5a$export$50ac6facfdab1af8 = "https://visual-crossing-weather.p.rapidapi.com/forecast?aggregateHours=24&contentType=json&unitGroup=metric&shortColumnNames=0%location=";
const $ba30e20475feac5a$export$6c228d1310e1d496 = "https://geocode.maps.co/search?q=";
const $ba30e20475feac5a$export$8580c87ade133666 = "https://geocode.maps.co/reverse?";
const $ba30e20475feac5a$export$3fb5a382c1a1d77c = 5;



const $bd02c871d9c5ba8e$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $bd02c871d9c5ba8e$export$f39dd77216918a27 = function() {
    setTimeout(function() {
        location.reload();
    }, 2000);
};
const $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8 = async function(url) {
    try {
        const fetchPro = fetch(url, {
            method: "GET"
        });
        const response = await Promise.race([
            fetchPro,
            $bd02c871d9c5ba8e$var$timeout((0, $ba30e20475feac5a$export$196440f71ed9f601))
        ]);
        const data = await response.json();
        if (!response.ok) throw new Error(data.message);
        return data;
    } catch (err) {
        throw err;
    }
};
const $bd02c871d9c5ba8e$export$b405e4ac657f26ad = function(time12Hour) {
    // Split the time string into hours, minutes, and AM/PM parts
    const [time, period] = time12Hour.split(" ");
    // Split the hours and minutes
    const [hours, minutes] = time.split(":");
    // Convert hours to a number
    let hours24 = parseInt(hours, 10);
    // Adjust for AM/PM
    if (period === "PM" && hours24 !== 12) hours24 += 12;
    else if (period === "AM" && hours24 === 12) hours24 = 0;
    // Convert back to string with leading zeros if needed
    const hours24String = hours24.toString().padStart(2, "0");
    // Combine hours and minutes in 24-hour format
    const time24Hour = `${hours24String}:${minutes}`;
    return time24Hour;
};
const $bd02c871d9c5ba8e$export$fc1bebb0106af159 = function(time24hour) {
    const [hours, minutes] = time24hour.split(":");
    let period = "AM";
    // Convert hours to a number
    let hourNum = parseInt(hours, 10);
    // Determine the period (AM or PM)
    if (hourNum >= 12) {
        period = "PM";
        if (hourNum > 12) hourNum -= 12;
    }
    // Ensure the hour is in two-digit format (e.g., 03 instead of 3)
    const hour12 = hourNum.toString().padStart(2, "0");
    // Construct the 12-hour format time string
    const time12 = `${hour12}:${minutes} ${period}`;
    return time12;
};
const $bd02c871d9c5ba8e$export$8e6e2c74f0fe3fd0 = function(dateString) {
    // Split the input string by '/' to extract day, month, and year
    const dateParts = dateString.split("/");
    // Ensure there are three parts (day, month, and year)
    if (dateParts.length === 3) {
        const day = parseInt(dateParts[0]);
        const month = parseInt(dateParts[1]) - 1; // Month is zero-based (0-11)
        const year = parseInt(dateParts[2]);
        // Create a Date object
        const properDate = new Date(year, month, day);
        // Check if the Date object is valid
        if (!isNaN(properDate.getTime())) return properDate;
    }
    // Return null for invalid input
    return null;
};
const $bd02c871d9c5ba8e$export$195ec01c71927300 = function(dateTimeString) {
    const dateObject = new Date(dateTimeString);
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const formattedTime = hours.toString().padStart(2, "0") + ":" + minutes.toString().padStart(2, "0");
    return formattedTime;
};
const $bd02c871d9c5ba8e$export$47c86e7cd3e7e047 = function(temp) {
    return Math.round(temp * 9 / 5 + 32);
};


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    weekdays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    userSettings: {
        temperature: "celsius",
        windSpeed: "km/h",
        pressure: "mb",
        precipitation: "millimiters",
        distance: "kilometers"
    },
    generalSettings: {
        TFhours: true,
        location: true,
        notifications: false
    },
    savedCities: {},
    activeCity: "",
    citiesPerPage: (0, $ba30e20475feac5a$export$3fb5a382c1a1d77c),
    page: 1
};
const $0f1d4402dffacf5b$var$createObj = function(data) {
    return {
        current: data.current,
        forecast: data.forecast,
        location: data.location
    };
};
const $0f1d4402dffacf5b$export$e7fd20fad3cf4b5f = async function() {
    if (navigator.geolocation && $0f1d4402dffacf5b$export$ca000e230c0caa3e.generalSettings.location) try {
        const position = await new Promise((resolve, reject)=>{
            navigator.geolocation.getCurrentPosition(resolve, reject);
        });
        const { longitude: longitude, latitude: latitude } = position.coords;
        // const data = await AJAX(
        //   `https://geocode.xyz/${latitude},${longitude}?geoit=json`
        // );
        const data = await (0, $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$8580c87ade133666)}lat=${latitude}&lon=${longitude}`);
        if (!data) return "Zhytomyr";
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities[data.address.city] = {
            locale: true
        };
        return data.address.city;
    } catch (error) {
        console.error("Error getting location:", error);
        return "Zhytomyr";
    }
    else return "Zhytomyr";
};
const $0f1d4402dffacf5b$export$a7a8d53ca6ad3a0 = async function(city) {
    try {
        const data = await (0, $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$61abde59b50deb8e)}${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}&q=${city}${(0, $ba30e20475feac5a$export$1549839c81210d0c)}`);
        // create new object, so I don't reassign a const variable (state)
        const newState = $0f1d4402dffacf5b$var$createObj(data);
        // Modify state properties instead of reassigning the whole state
        Object.keys(newState).forEach((key)=>{
            $0f1d4402dffacf5b$export$ca000e230c0caa3e[key] = newState[key];
        });
        // get the appropriate image to a corresponding weather condition
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.cityImg = $0f1d4402dffacf5b$var$getWeatherImage($0f1d4402dffacf5b$export$ca000e230c0caa3e.current.condition.text, $0f1d4402dffacf5b$export$ca000e230c0caa3e.current.wind_mph > (0, $ba30e20475feac5a$export$ff1991c17b0b40f5), $0f1d4402dffacf5b$export$ca000e230c0caa3e.current.is_day);
        // get hours according to current time
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.hourly = $0f1d4402dffacf5b$var$getHours();
        // get image for each hour
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.hourly.forEach((hour)=>{
            hour.img = $0f1d4402dffacf5b$var$getWeatherImage(hour.condition.text, hour.wind_mph > (0, $ba30e20475feac5a$export$ff1991c17b0b40f5), hour.is_day);
        });
        // get image for each day
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.forecast.forecastday.forEach((day)=>{
            const dominantCondition = $0f1d4402dffacf5b$var$getPredominantWeather(day);
            day.dominantCondition = $0f1d4402dffacf5b$var$shortWeatherDescription(dominantCondition);
            day.highestWind = $0f1d4402dffacf5b$var$getHighestWind(day);
            day.img = $0f1d4402dffacf5b$var$getWeatherImage(dominantCondition, day.highestWind > (0, $ba30e20475feac5a$export$ff1991c17b0b40f5), true);
        });
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeCity = $0f1d4402dffacf5b$export$ca000e230c0caa3e.location.name;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
const $0f1d4402dffacf5b$export$88cc774c1a6959f6 = async function() {
    try {
        if (Object.keys($0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities).length === 0) return;
        for (const city of Object.keys($0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities)){
            const data = await (0, $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$61abde59b50deb8e)}${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}&q=${city}${(0, $ba30e20475feac5a$export$1549839c81210d0c)}`);
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities[city].current = data.current;
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities[city].forecast = data.forecast;
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities[city].location = data.location;
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities[city].img = $0f1d4402dffacf5b$var$getWeatherImage($0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities[city].current.condition.text, $0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities[city].current.wind_mph > (0, $ba30e20475feac5a$export$ff1991c17b0b40f5), $0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities[city].current.is_day);
        }
    } catch (err) {
        console.error("error getting cities", err);
        throw err;
    }
};
const $0f1d4402dffacf5b$export$52e4c50a43f85078 = function(page = 1) {
    const keys = Object.keys($0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities);
    const start = (page - 1) * $0f1d4402dffacf5b$export$ca000e230c0caa3e.citiesPerPage;
    const end = page * $0f1d4402dffacf5b$export$ca000e230c0caa3e.citiesPerPage;
    const citiesOnPage = keys.slice(start, end);
    const citiesData = {};
    citiesOnPage.forEach((city)=>{
        citiesData[city] = $0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities[city];
    });
    return citiesData;
};
const $0f1d4402dffacf5b$export$4569ca64384f677 = async function(city) {
    try {
        const data = await (0, $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$a9b8803b2f2c8a6b)}${city}${(0, $ba30e20475feac5a$export$54ae492174d0c4ef)}&units=metric`);
        console.log(data);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.forecastSeven = [];
        $0f1d4402dffacf5b$var$getForecastData(data);
    } catch (err) {
        console.error(`${err} WHAT THE HELL MAN?`);
        throw err;
    }
};
const $0f1d4402dffacf5b$var$getForecastData = function(data) {
    let date = null;
    let dayObject = [];
    for (const [i, timeframe] of data.list.entries()){
        const newDate = new Date(timeframe.dt_txt).getDate();
        if (date === null) {
            date = newDate;
            dayObject.push(timeframe);
        } else if (newDate !== date) {
            const dominantCondition = $0f1d4402dffacf5b$var$getConditionForDescription(dayObject);
            const img = $0f1d4402dffacf5b$var$getWeatherImage(dominantCondition, false, true);
            const weekDay = $0f1d4402dffacf5b$export$ca000e230c0caa3e.weekdays[new Date(data.list[i - 1].dt_txt).getDay()];
            const [max, min] = $0f1d4402dffacf5b$var$getMinMaxTemp(dayObject);
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.forecastSeven.push({
                dominantCondition: dominantCondition,
                img: img,
                weekDay: weekDay,
                min: min,
                max: max
            });
            dayObject = [];
            date = newDate;
        }
        if (!dayObject.includes(timeframe)) dayObject.push(timeframe);
    }
    const dominantCondition = $0f1d4402dffacf5b$var$getConditionForDescription(dayObject);
    const img = $0f1d4402dffacf5b$var$getWeatherImage(dominantCondition, false, true);
    const weekDay = $0f1d4402dffacf5b$export$ca000e230c0caa3e.weekdays[new Date(data.list[data.list.length - 1].dt_txt).getDay()];
    const [max, min] = $0f1d4402dffacf5b$var$getMinMaxTemp(dayObject);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.forecastSeven.push({
        dominantCondition: dominantCondition,
        img: img,
        weekDay: weekDay,
        min: min,
        max: max
    });
};
const $0f1d4402dffacf5b$var$getMinMaxTemp = function(day) {
    let min = Infinity;
    let max = -Infinity;
    for (const tf of day){
        if (tf.main.temp_max > max) max = tf.main.temp_max;
        if (tf.main.temp_min < min) min = tf.main.temp_min;
    }
    return [
        Math.round(max),
        Math.round(min)
    ];
};
const $0f1d4402dffacf5b$var$getConditionForDescription = function(day) {
    const condCounts = {};
    // Iterate through the array
    for (const item of day){
        const condition = $0f1d4402dffacf5b$var$convertIDtoWeather(...item.weather);
        if (!condition) continue;
        if (condCounts[condition]) // If it is, increment the count
        condCounts[condition]++;
        else // If it's not, add it to the object with a count of 1
        condCounts[condition] = 1;
    }
    if (Object.keys(condCounts).length === 0) return "Sunny";
    const sortedArr = Object.entries(condCounts);
    sortedArr.sort((a, b)=>b[1] - a[1]);
    return sortedArr[0][0];
};
const $0f1d4402dffacf5b$var$convertIDtoWeather = function(condObj) {
    const id = condObj.id;
    if (id > 199 && id < 300) return "Thunder";
    if (id > 299 && id < 500) return "Drizzle";
    if (id > 499 && id < 600) {
        if (id === 500 || id === 520) return "Patchy rain";
        return "Rainy";
    }
    if (id > 599 && id < 700) {
        if (id === 600) return "Patchy snow";
        if (id === 612) return "Patchy sleet";
        if (id === 611 || id === 613) return "Sleet";
        return "Snowy";
    }
    if (id > 699 && id < 800) {
        if (id === 701) return "Mist";
        if (id === 741) return "Fog";
        return "Cloudy";
    }
    if (id === 800) return "Sunny";
    if (id > 800) {
        if (id === 801) return "Partly cloudy";
        if (id === 804) return "Overcast";
        return "Cloudy";
    }
};
// get the highest wind value of the day
const $0f1d4402dffacf5b$var$getHighestWind = function(day) {
    let count = -Infinity;
    for (const hour of day.hour){
        const wind = hour.wind_mph;
        if (count < wind) count = wind;
    }
    return count;
};
// get a short description which will fit the container in 1 line
const $0f1d4402dffacf5b$var$shortWeatherDescription = function(condition) {
    if (condition.includes("Patchy") && condition.includes("rain")) return "Patchy rain";
    if (condition.includes("Patchy") && condition.includes("snow")) return "Patchy snow";
    if (condition.includes("Patchy") && condition.includes("sleet")) return "Patchy sleet";
    if (condition.toLowerCase().includes("thunder")) return "Thunder";
    if (condition.includes("shower") && condition.includes("rain")) return "Rain showers";
    if (condition.includes("rain")) return "Rainy";
    if (condition.includes("snow")) return "Snowy";
    if (condition.includes("drizzle")) return "Drizzle";
    if (condition.includes("sleet")) return "Sleet";
    if (condition.includes("pellets")) return "Ice pellets";
    return condition;
};
// get appropriate condition that describes the day
const $0f1d4402dffacf5b$var$getPredominantWeather = function(day) {
    const condCounts = {};
    // Iterate through the array
    for (const item of day.hour){
        const condition = item.condition.text;
        if (condition === "Clear") continue;
        if (condCounts[condition]) // If it is, increment the count
        condCounts[condition]++;
        else // If it's not, add it to the object with a count of 1
        condCounts[condition] = 1;
    }
    const sortedArr = Object.entries(condCounts);
    sortedArr.sort((a, b)=>b[1] - a[1]);
    return sortedArr[0][0];
};
// Get 6 hours (every 3 hours)
const $0f1d4402dffacf5b$var$getHours = function() {
    const firstDayArr = $0f1d4402dffacf5b$export$ca000e230c0caa3e.forecast.forecastday[0].hour;
    const secondDayArr = $0f1d4402dffacf5b$export$ca000e230c0caa3e.forecast.forecastday[1].hour;
    const curHour = new Date($0f1d4402dffacf5b$export$ca000e230c0caa3e.location.localtime).getHours();
    const newArr = [];
    // every 3 hours
    for(let i = 0; i < (0, $ba30e20475feac5a$export$b1296de362a35dda) * 3; i += 3){
        if (curHour + i > 23) {
            newArr.push(secondDayArr[curHour + i - secondDayArr.length]);
            continue;
        }
        newArr.push(firstDayArr[curHour + i]);
    }
    return newArr;
};
const $0f1d4402dffacf5b$var$getWeatherImage = function(condition, isWindy, isDay) {
    // clear sun
    if (condition.toLowerCase().includes("sunny")) {
        if (isWindy) return "windySun";
        return "sunny";
    }
    // clear moon
    if (condition.toLowerCase().includes("clear")) {
        if (isWindy) return "windyMoon";
        return "clear";
    }
    // for sun/moon with a certain condition
    if (condition.toLowerCase().includes("patchy") || condition.toLowerCase().includes("light")) {
        if (isDay) {
            // thunder
            if (condition.includes("thunder")) {
                if (condition.includes("rain")) return "lightningRainyCloudySun";
                if (condition.includes("snow")) return "lightningSnowyCloud";
            }
            // sun with rain
            if (condition.includes("rain") || condition.toLowerCase().includes("drizzle")) {
                if (isWindy) return "rainyWindyCloudySun";
                return "rainyCloudySun";
            }
            // cloud with snow and rain
            if (condition.includes("sleet")) return "snowyRainyCloud";
        }
        if (!isDay) {
            // thunder
            if (condition.includes("thunder")) {
                if (condition.includes("rain")) return "lightningRainyCloud";
                if (condition.includes("snow")) {
                    if (isWindy) return "lightningSnowyWindyCloud";
                    return "lightningSnowyCloud";
                }
            }
            // moon with rain
            if (condition.includes("rain") || condition.toLowerCase().includes("drizzle")) {
                if (isWindy) return "rainyWindyCloudyMoon";
                return "rainyCloudyMoon";
            }
            // moon with snow
            if (condition.includes("snow")) return "snowyCloudyMoon";
            // moon with snow and rain
            if (condition.includes("sleet")) return "snowyRainyMoon";
        }
    }
    // for all thunders
    if (condition.toLowerCase().includes("thunder")) {
        if (condition.includes("rain")) return "lightningRainyCloud";
        if (condition.includes("snow")) return "lightningSnowyCloud";
        return "lightningCloud";
    }
    //for all showers
    if (condition.includes("shower")) {
        if (condition.includes("rain")) return "rainyCloud";
        if (condition.includes("snow") || condition.includes("ice")) return "snowyCloud";
        if (condition.includes("sleet")) return "snowyRainyCloud";
    }
    // cloud with snow and rain
    if (condition.toLowerCase().includes("freezing") && condition.toLowerCase().includes("rain")) return "snowyRainyCloud";
    // cloud with rain
    if (condition.toLowerCase().includes("drizzle") || condition.toLowerCase().includes("rain")) {
        if (isWindy) return "rainyWindyCloud";
        return "rainyCloud";
    }
    // clouds with sun or moon
    if (condition.toLowerCase().includes("partly cloudy")) {
        if (isDay) {
            if (isWindy) return "windyCloudySun";
            return "cloudySun";
        }
        if (isWindy) return "windyCloudyMoon";
        return "cloudyMoon";
    }
    // cloud
    if (condition.toLowerCase().includes("cloud") || condition.toLowerCase().includes("overcast") || condition.toLowerCase().includes("mist") || condition.toLowerCase().includes("fog")) return "cloud";
    // sun with snow
    if (condition.includes("snow") || condition.includes("Blizzard")) return "snowyCloud";
    // cloud with snow and rain
    if (condition.includes("sleet")) return "snowyRainyCloud";
};
const $0f1d4402dffacf5b$export$8e034fe27ea783b9 = function(target) {
    const setting = target.dataset.setting;
    if (!setting) return;
    const value = target.textContent.trim().toLowerCase();
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.userSettings[setting] = value;
    $0f1d4402dffacf5b$var$persistSettings();
    return target;
};
const $0f1d4402dffacf5b$export$1609e83cd44a6870 = function(target) {
    const setting = target.dataset.general;
    if (!setting) return;
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.generalSettings[setting]) $0f1d4402dffacf5b$export$ca000e230c0caa3e.generalSettings[setting] = false;
    else $0f1d4402dffacf5b$export$ca000e230c0caa3e.generalSettings[setting] = true;
    $0f1d4402dffacf5b$var$persistGeneralSettings();
};
const $0f1d4402dffacf5b$export$8727201a1c9728f4 = function(city) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities[city] = {
        current: $0f1d4402dffacf5b$export$ca000e230c0caa3e.current,
        forecast: $0f1d4402dffacf5b$export$ca000e230c0caa3e.forecast,
        img: $0f1d4402dffacf5b$export$ca000e230c0caa3e.cityImg,
        location: $0f1d4402dffacf5b$export$ca000e230c0caa3e.location
    };
    $0f1d4402dffacf5b$var$persistSavedCity();
};
const $0f1d4402dffacf5b$export$6e8d81316029aa6d = function(city) {
    delete $0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities[city];
    $0f1d4402dffacf5b$var$persistSavedCity();
};
const $0f1d4402dffacf5b$var$persistSavedCity = function() {
    localStorage.setItem("saved cities", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities));
};
const $0f1d4402dffacf5b$var$persistSettings = function() {
    localStorage.setItem("settings", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.userSettings));
};
const $0f1d4402dffacf5b$var$persistGeneralSettings = function() {
    localStorage.setItem("general settings", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.generalSettings));
};
const $0f1d4402dffacf5b$var$init = function() {
    const storage = localStorage.getItem("settings");
    if (storage) $0f1d4402dffacf5b$export$ca000e230c0caa3e.userSettings = JSON.parse(storage);
    const generalStorage = localStorage.getItem("general settings");
    if (generalStorage) $0f1d4402dffacf5b$export$ca000e230c0caa3e.generalSettings = JSON.parse(generalStorage);
    const savedCities = localStorage.getItem("saved cities");
    if (savedCities) $0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities = JSON.parse(savedCities);
};
$0f1d4402dffacf5b$var$init();


var $b4c48daf3fb085fb$exports = {};

$b4c48daf3fb085fb$exports = new URL((parcelRequire("27Lyk")).resolve("cSks4"), import.meta.url).toString();


var $f8303f48b5141b7a$exports = {};

$f8303f48b5141b7a$exports = new URL((parcelRequire("27Lyk")).resolve("kcF75"), import.meta.url).toString();


var $902d4dc49e327246$exports = {};

$902d4dc49e327246$exports = new URL((parcelRequire("27Lyk")).resolve("eil8G"), import.meta.url).toString();


var $b86d58b54da79b32$exports = {};

$b86d58b54da79b32$exports = new URL((parcelRequire("27Lyk")).resolve("lGqxp"), import.meta.url).toString();


var $9c72bc5e7151c303$exports = {};

$9c72bc5e7151c303$exports = new URL((parcelRequire("27Lyk")).resolve("lf5R2"), import.meta.url).toString();


var $ced1760ebf2f3924$exports = {};

$ced1760ebf2f3924$exports = new URL((parcelRequire("27Lyk")).resolve("WvKFx"), import.meta.url).toString();


var $f4a0891b296bdc04$exports = {};

$f4a0891b296bdc04$exports = new URL((parcelRequire("27Lyk")).resolve("hNbIe"), import.meta.url).toString();


var $ccff71cfefbd18c5$exports = {};

$ccff71cfefbd18c5$exports = new URL((parcelRequire("27Lyk")).resolve("lPOOM"), import.meta.url).toString();


var $437a6c0de6ab9921$exports = {};

$437a6c0de6ab9921$exports = new URL((parcelRequire("27Lyk")).resolve("lGOjp"), import.meta.url).toString();


var $dce81d5a57b9d9ac$exports = {};

$dce81d5a57b9d9ac$exports = new URL((parcelRequire("27Lyk")).resolve("hNwE3"), import.meta.url).toString();


var $f9fcb5b68738d0f4$exports = {};

$f9fcb5b68738d0f4$exports = new URL((parcelRequire("27Lyk")).resolve("7xpT8"), import.meta.url).toString();


var $8634537a986fb885$exports = {};

$8634537a986fb885$exports = new URL((parcelRequire("27Lyk")).resolve("d0NFe"), import.meta.url).toString();


var $9278b21a94da32e1$exports = {};

$9278b21a94da32e1$exports = new URL((parcelRequire("27Lyk")).resolve("8D38C"), import.meta.url).toString();


var $e5b30bf97b524aca$exports = {};

$e5b30bf97b524aca$exports = new URL((parcelRequire("27Lyk")).resolve("hHLFh"), import.meta.url).toString();


var $995e5eedc728d85f$exports = {};

$995e5eedc728d85f$exports = new URL((parcelRequire("27Lyk")).resolve("iKlo4"), import.meta.url).toString();


var $f2637f4093d458be$exports = {};

$f2637f4093d458be$exports = new URL((parcelRequire("27Lyk")).resolve("hDjz9"), import.meta.url).toString();


var $8b8c370aad13f854$exports = {};

$8b8c370aad13f854$exports = new URL((parcelRequire("27Lyk")).resolve("fPQPF"), import.meta.url).toString();


var $8c5652575c9370b7$exports = {};

$8c5652575c9370b7$exports = new URL((parcelRequire("27Lyk")).resolve("lVhN0"), import.meta.url).toString();


var $a546556636e51865$exports = {};

$a546556636e51865$exports = new URL((parcelRequire("27Lyk")).resolve("35XQG"), import.meta.url).toString();


var $4e6c2b8bd02a1c09$exports = {};

$4e6c2b8bd02a1c09$exports = new URL((parcelRequire("27Lyk")).resolve("hzhTc"), import.meta.url).toString();


var $3656a7f756a4cef2$exports = {};

$3656a7f756a4cef2$exports = new URL((parcelRequire("27Lyk")).resolve("NByNw"), import.meta.url).toString();


var $6b642a7e4cc134bf$exports = {};

$6b642a7e4cc134bf$exports = new URL((parcelRequire("27Lyk")).resolve("kPZHq"), import.meta.url).toString();


var $4ccd0e26339a5f54$exports = {};

$4ccd0e26339a5f54$exports = new URL((parcelRequire("27Lyk")).resolve("huq6v"), import.meta.url).toString();


var $5c280e2cc4342885$exports = {};

$5c280e2cc4342885$exports = new URL((parcelRequire("27Lyk")).resolve("es2sZ"), import.meta.url).toString();


var $13931f3f82e1b378$exports = {};

$13931f3f82e1b378$exports = new URL((parcelRequire("27Lyk")).resolve("24dI6"), import.meta.url).toString();


class $3a07c34e115c11c9$export$2e2bcd8739ae039 {
    _data;
    _allImports = {
        sunny: (0, (/*@__PURE__*/$parcel$interopDefault($b4c48daf3fb085fb$exports))),
        clear: (0, (/*@__PURE__*/$parcel$interopDefault($f8303f48b5141b7a$exports))),
        cloud: (0, (/*@__PURE__*/$parcel$interopDefault($902d4dc49e327246$exports))),
        cloudySun: (0, (/*@__PURE__*/$parcel$interopDefault($b86d58b54da79b32$exports))),
        cloudyMoon: (0, (/*@__PURE__*/$parcel$interopDefault($9c72bc5e7151c303$exports))),
        rainyCloud: (0, (/*@__PURE__*/$parcel$interopDefault($ced1760ebf2f3924$exports))),
        rainyCloudySun: (0, (/*@__PURE__*/$parcel$interopDefault($f4a0891b296bdc04$exports))),
        rainyCloudyMoon: (0, (/*@__PURE__*/$parcel$interopDefault($ccff71cfefbd18c5$exports))),
        snowyRainyCloud: (0, (/*@__PURE__*/$parcel$interopDefault($437a6c0de6ab9921$exports))),
        snowyCloudyMoon: (0, (/*@__PURE__*/$parcel$interopDefault($dce81d5a57b9d9ac$exports))),
        snowyCloud: (0, (/*@__PURE__*/$parcel$interopDefault($f9fcb5b68738d0f4$exports))),
        snowyRainyMoon: (0, (/*@__PURE__*/$parcel$interopDefault($8634537a986fb885$exports))),
        lightningRainyCloudySun: (0, (/*@__PURE__*/$parcel$interopDefault($9278b21a94da32e1$exports))),
        lightningSnowyCloud: (0, (/*@__PURE__*/$parcel$interopDefault($e5b30bf97b524aca$exports))),
        lightningRainyCloud: (0, (/*@__PURE__*/$parcel$interopDefault($995e5eedc728d85f$exports))),
        lightningCloud: (0, (/*@__PURE__*/$parcel$interopDefault($f2637f4093d458be$exports))),
        lightningSnowyWindyCloud: (0, (/*@__PURE__*/$parcel$interopDefault($4ccd0e26339a5f54$exports))),
        windySun: (0, (/*@__PURE__*/$parcel$interopDefault($8b8c370aad13f854$exports))),
        windyMoon: (0, (/*@__PURE__*/$parcel$interopDefault($8c5652575c9370b7$exports))),
        windyCloudySun: (0, (/*@__PURE__*/$parcel$interopDefault($a546556636e51865$exports))),
        windyCloudyMoon: (0, (/*@__PURE__*/$parcel$interopDefault($4e6c2b8bd02a1c09$exports))),
        rainyWindyCloudySun: (0, (/*@__PURE__*/$parcel$interopDefault($3656a7f756a4cef2$exports))),
        rainyWindyCloudyMoon: (0, (/*@__PURE__*/$parcel$interopDefault($6b642a7e4cc134bf$exports))),
        rainyWindyCloud: (0, (/*@__PURE__*/$parcel$interopDefault($5c280e2cc4342885$exports)))
    };
    render(data) {
        if (!data || Array.isArray(data) && data.length === 0) return new Error(`No data`);
        this._data = data;
    }
    _getSrc() {
        return this._allImports[this._data.cityImg];
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
    update(data) {
        if (!data || Array.isArray(data) && data.length === 0) return new Error(`No data`);
        this._data = data;
        const newMarkup = this._generateMarkup();
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const curElements = Array.from(this._parentElement.querySelectorAll("*"));
        // console.log("New elements: ", newElements);
        // console.log("Current elements: ", curElements);
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== "") curEl.textContent = newEl.textContent;
            if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach((attr)=>curEl.setAttribute(attr.name, attr.value));
        });
    }
    renderLoading() {
        this._clear();
        const html = `<div class="loading-animation"></div>`;
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    }
    enableActive() {
        this._navElement.classList.add("n-item--active");
    }
    disableActive() {
        this._navElement.classList.remove("n-item--active");
    }
    _makeVisible(arr) {
        arr.forEach((el)=>el.classList.remove("disable"));
    }
    _makeInvisible(arr) {
        arr.forEach((el)=>el.classList.add("disable"));
    }
    renderError(message = this._errorMessage) {
        const html = ` <div class="error">
            <div>
              <svg>
                <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports)))}#icon-alert-triangle"></use>
              </svg>
            </div>
            <p>${message}</p>
          </div>`;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    }
    renderMessage(message = this._message) {
        const html = ` <div class="message">
            <div>
              <svg>
                <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports)))}#icon-smile"></use>
              </svg>
            </div>
            <p>${message}</p>
          </div>`;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    }
}


class $6be7010d7cd51383$var$LandingPageView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("nav");
    _navElement = document.querySelector(".n-item-1");
    _contentContainer = [
        document.querySelector(".hourly-forecast"),
        document.querySelector(".city"),
        document.querySelector(".s-d-forecast"),
        document.querySelector(".weather-details")
    ];
    _overlayElement = this._parentElement.querySelector(".overlay");
    addHandlerRender(callback) {
        window.addEventListener("load", callback);
    }
    toggleOverlay() {
        this._overlayElement.classList.toggle("overlay--active");
    }
    addHandlerClick(callback) {
        this._parentElement.addEventListener("click", (e)=>{
            const target = e.target.closest(".n-item-1");
            if (!target) return;
            callback();
        });
    }
    addHandlerSeeMore(callback) {
        document.querySelector(".weather-details").addEventListener("click", (e)=>{
            const btn = e.target.closest(".see-more");
            if (!btn) return;
            callback();
        });
    }
    clearContentContainer() {
        this._makeInvisible(this._contentContainer);
    }
    reviveContentContainer() {
        this._makeVisible(this._contentContainer);
    }
}
var $6be7010d7cd51383$export$2e2bcd8739ae039 = new $6be7010d7cd51383$var$LandingPageView();




class $4cfee55aef1e3a92$var$SevenDayView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".s-d-list");
    insertDays() {
        if (Object.keys(this._data).length === 0) return;
        this._clear();
        const html = this._generateMarkup();
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    }
    _getSrc(condition) {
        return this._allImports[condition];
    }
    _generateMarkup() {
        return this._data.forecastSeven.map((day, i)=>{
            if (i === 0) return this._generateHTML(day, "Today");
            return this._generateHTML(day);
        }).join("");
    }
    _generateHTML(day, weekDay) {
        return `<li class="s-d-item">
              <p class="regular-light-text weekday">${weekDay ? weekDay : day.weekDay}</p>
              <div class="s-d-icon-condition">
                <div class="img-container">
                  <img src="${this._allImports[day.img]}" alt="" id="special-margin" />
                </div>
                <p class="bold-light-text bold-container">${day.dominantCondition}</p>
              </div>
              <div class="s-d-smallest-highest">
                <p class="bold-light-text">
                ${this._data.userSettings.temperature === "celsius" ? `${day.max}` : `${(0, $bd02c871d9c5ba8e$export$47c86e7cd3e7e047)(day.max)}`}</p>
                <div class="regular-light-text">/${this._data.userSettings.temperature === "celsius" ? `${day.min}` : `${(0, $bd02c871d9c5ba8e$export$47c86e7cd3e7e047)(day.min)}`}</div>
              </div>
            </li>`;
    }
}
var $4cfee55aef1e3a92$export$2e2bcd8739ae039 = new $4cfee55aef1e3a92$var$SevenDayView();




class $5c976a6fb1a25bc1$var$HourlyView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".hourly-list");
    insertHourly() {
        if (Object.keys(this._data).length === 0) return;
        this._clear();
        const html = this._generateMarkup();
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    }
    _getSrc(condition) {
        return this._allImports[condition];
    }
    _generateMarkup() {
        return this._data.hourly.map((hour)=>this._generateHTML(hour)).join("");
    }
    _generateHTML(hour) {
        return `<li class="h-item">
                <div class="h-time">${this._data.generalSettings.TFhours ? `${new Date(hour.time).getHours()}:00` : `${(0, $bd02c871d9c5ba8e$export$fc1bebb0106af159)(`${new Date(hour.time).getHours()}:00`).slice(1)}`}</div>
                <img src="${this._getSrc(hour.img)}" alt="weather condition" ${this._getSrc(hour.img) !== this._allImports.cloud && this._getSrc(hour.img) !== this._allImports.snowyCloud ? 'id="not-fit"' : ""} />
                <div class="h-temp">${this._data.userSettings.temperature === "celsius" ? `${Math.round(hour.feelslike_c)}` : `${Math.round(hour.feelslike_f)}`}°</div>
              </li>`;
    }
}
var $5c976a6fb1a25bc1$export$2e2bcd8739ae039 = new $5c976a6fb1a25bc1$var$HourlyView();





class $c34a89588b91ccbd$var$DetailsView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".d-details");
    insertDetails() {
        if (Object.keys(this._data).length === 0) return;
        this._clear();
        const html = this._generateMarkup();
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    }
    renderLoading() {
        this._clear();
        const html = `<div class="loading-animation" id="details-load"></div>`;
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    }
    _convertToKnots(km) {
        return (km * 0.539957).toFixed(1);
    }
    _generateMarkup() {
        return `<div class="d-h-item-1 real-feel">
              <div class="icon-text">
                <svg
                  fill="#9399a2"
                  width="30px"
                  height="30px"
                  viewBox="0 0 505.394 505.395"
                >
                  <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#therm"></use>
                </svg>
                <p class="grey-classic">Real Feel</p>
              </div>
              <div class="feel-value">
                <p class="d-value">${this._data.userSettings.temperature === "celsius" ? `${Math.round(this._data.current.feelslike_c)}` : `${Math.round(this._data.current.feelslike_f)}`}°</p>
              </div>
            </div>` + `<div class="d-h-item-1 wind">
              <div class="icon-text">
                <svg
                  height="27px"
                  width="30px"
                  viewBox="0 0 512 512"
                  fill="#9399a2"
                >
                  <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#wind"></use>
                </svg>
                <p class="grey-classic">Wind</p>
              </div>
              <div class="wind-value">
                <p class="d-value">${this._data.userSettings.windSpeed === "km/h" ? `${this._data.current.wind_kph} km/h` : `${this._data.userSettings.windSpeed === "m/h" ? `${this._data.current.wind_mph} m/h` : `${this._convertToKnots(this._data.current.wind_kph)} knots`}`} </p>
              </div>
            </div>` + `<div class="d-h-item-1 visibility">
              <div class="icon-text">
                <svg
                  height="27px"
                  width="30px"
                  viewBox="0 0 488.85 488.85"
                  fill="#9399a2"
                >
                  <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#eye"></use>
                </svg>
                <p class="grey-classic">Visibility</p>
              </div>
              <div class="visibility-value">
                <p class="d-value">${this._data.userSettings.distance === "kilometers" ? `${this._data.current.vis_km} km` : `${this._data.current.vis_miles} miles`}</p>
              </div>
            </div>` + `<div class="d-h-item-1 rain">
              <div class="icon-text">
                <svg
                  height="28px"
                  width="27px"
                  viewBox="0 0 264.564 264.564"
                  fill="#9399a2"
                >
                  <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#water"></use>
                </svg>
                <p class="grey-classic">Chance of rain</p>
              </div>
              <div class="rain-value">
                <p class="d-value">${this._data.forecast.forecastday[0].day.daily_chance_of_rain}%</p>
              </div>
            </div>` + `<div class="d-h-item-1 uv">
              <div class="icon-text">
                <svg
                  height="28px"
                  width="27px"
                  viewBox="0 0 457.32 457.32"
                  fill="#9399a2"
                >
                  <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#sun"></use>
                </svg>
                <p class="grey-classic">UV index</p>
              </div>
              <div class="uv-value">
                <p class="d-value">${this._data.current.uv}</p>
              </div>
            </div>` + `<div class="d-h-item-1 sunset">
              <div class="icon-text">
                <svg
                  height="28px"
                  width="27px"
                  viewBox="-1.147 -22.185 141.732 141.732"
                  fill="#9399a2"
                >
                  <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#cloud-sun"></use>
                </svg>
                <p class="grey-classic">Sunset</p>
              </div>
              <div class="sunset-value">
                <p class="d-value">${this._data.generalSettings.TFhours ? `${(0, $bd02c871d9c5ba8e$export$b405e4ac657f26ad)(this._data.forecast.forecastday[0].astro.sunset)}` : `${this._data.forecast.forecastday[0].astro.sunset.slice(1)}`} </p>
              </div>
            </div>`;
    }
}
var $c34a89588b91ccbd$export$2e2bcd8739ae039 = new $c34a89588b91ccbd$var$DetailsView();




class $e1b37a066ab13ba6$var$CityView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".city");
    addHandlerSave(callback) {
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".btn-save");
            if (!btn) return;
            this.toggleAnimation(btn);
            callback(btn);
        });
    }
    toggleAnimation(btn) {
        btn.classList.toggle("animate");
    }
    renderSpinner() {
        this._clear();
        const html = '<div class="spinner"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle id="spinner" cx="12" cy="12" r="0"></circle></svg></div>';
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    }
    insertCity() {
        if (Object.keys(this._data).length === 0) return;
        this._clear();
        const html = this._generateMarkup();
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    // return to space-between
    }
    _generateMarkup() {
        return `
    <div class="city__resp">
      <div class="city-text">
        <p class="city-name">${this._data.location.name}</p>
        <p class="rain-chance">Chance of rain: ${this._data.forecast.forecastday[0].day.daily_chance_of_rain}%</p>
      </div>
      <div class="city-temperature">${this._data.userSettings.temperature === "celsius" ? `${Math.round(this._data.current.feelslike_c)}` : `${Math.round(this._data.current.feelslike_f)}`}°
      </div>
    </div>
    <div class="weather-icon">
            <img src="${this._getSrc()}" ${this._getSrc() === this._allImports.cloud || this._getSrc() === this._allImports.lightningSnowyWindyCloud ? "width='200px'" : "width='157px'"} id="city-image" alt="" />
    </div>
    <div class="save-city">
      <svg class="btn-save ">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#icon-star${Object.keys(this._data.savedCities).includes(this._data.location.name) ? "-fill" : ""}" />
      </svg>
    </div>
    `;
    }
}
var $e1b37a066ab13ba6$export$2e2bcd8739ae039 = new $e1b37a066ab13ba6$var$CityView();



class $813cf99795e9ec97$var$SearchView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".search_form");
    getQuery() {
        const query = this._parentElement.querySelector(".search__field").value;
        this._clearInput();
        return query;
    }
    _clearInput() {
        this._parentElement.querySelector(".search__field").value = "";
    }
    addHandlerSearch(callback) {
        this._parentElement.addEventListener("submit", (e)=>{
            e.preventDefault();
            callback();
        });
    }
    renderError(message = this._errorMessage) {
        const html = ` <div class="error">
            <div>
              <svg>
                <use href="${details}#icon-alert-triangle"></use>
              </svg>
            </div>
            <p>${message}</p>
          </div>`;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    }
}
var $813cf99795e9ec97$export$2e2bcd8739ae039 = new $813cf99795e9ec97$var$SearchView();



class $4c22adf96f0377b2$var$SettingsView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("nav");
    _navElement = document.querySelector(".n-item-4");
    _container = document.querySelector(".content");
    _generalContainer = document.querySelector(".seven-day");
    _seachElement = document.querySelector(".search_form");
    _contentElement = document.querySelector(".content");
    addHandlerClick(callback) {
        this._parentElement.addEventListener("click", (e)=>{
            const target = e.target.closest(".n-item-4");
            if (!target) return;
            callback();
        });
    }
    addHandlerGeneralSettings(callback) {
        this._generalContainer.addEventListener("click", (e)=>{
            const toggle = e.target.closest(".toggle-switch");
            if (!toggle) return;
            callback(e.target);
        });
    }
    addHandlerSettings(callback) {
        this._container.addEventListener("click", (e)=>{
            const pressure = e.target.closest(".pressure");
            const temperature = e.target.closest(".temperature");
            const distance = e.target.closest(".distance");
            const precipitation = e.target.closest(".precipitation");
            const windSpeed = e.target.closest(".wind-speed");
            if (!pressure && !temperature && !distance && !precipitation && !windSpeed) return;
            callback(e.target);
        });
    }
    toggleActive(target) {
        if (!target) return;
        const elArray = Array.from(target.closest(".toggle").querySelectorAll(".toggle-el"));
        elArray.forEach((el)=>el.classList.remove("toggle-el--active"));
        target.classList.add("toggle-el--active");
    }
    clearSettingsContainer() {
        if (!document.querySelector(".settings")) return;
        const setCont = [
            document.querySelector(".units"),
            document.querySelector(".settings"),
            document.querySelector(".general"),
            document.querySelector(".general-settings"),
            document.querySelector(".sign-up-container")
        ];
        this._makeInvisible(setCont);
    }
    reviveSettings() {
        const setCont = [
            document.querySelector(".units"),
            document.querySelector(".settings"),
            document.querySelector(".general"),
            document.querySelector(".general-settings"),
            document.querySelector(".sign-up-container")
        ];
        this._makeVisible(setCont);
    }
    enableResponsive() {
        this._seachElement.classList.add("search--responsive");
        this._contentElement.classList.add("content__settings--responsive");
    }
    disableResponsive() {
        this._seachElement.classList.remove("search--responsive");
        this._contentElement.classList.remove("content__settings--responsive");
    }
    insertElements() {
        if (document.querySelector(".settings")) return this.reviveSettings();
        const html = `<div class="setting-text units">Units</div>
    <div class="settings">
      <div class="setting-option">
        <div class="setting-o-text">TEMPERATURE</div>
        <div class="toggle-container">
          <div class="toggle temperature">
            <div class="toggle-el ${this._data.userSettings.temperature === "celsius" ? "toggle-el--active" : ""} celsius" data-setting="temperature">Celsius</div>
            <div class="toggle-el ${this._data.userSettings.temperature === "fahrenheit" ? "toggle-el--active" : ""} fahrenheit" data-setting="temperature">Fahrenheit</div>
          </div>
        </div>
      </div>
      <div class="setting-option">
        <div class="setting-o-text">WIND SPEED</div>
        <div class="toggle-container">
          <div class="toggle wind-speed">
            <div class="toggle-el ${this._data.userSettings.windSpeed === "km/h" ? "toggle-el--active" : ""} wind-km" data-setting="windSpeed">km/h</div>
            <div class="toggle-el ${this._data.userSettings.windSpeed === "m/h" ? "toggle-el--active" : ""} wind-miles" data-setting="windSpeed">m/h</div>
            <div class="toggle-el ${this._data.userSettings.windSpeed === "knots" ? "toggle-el--active" : ""} wind-knots" data-setting="windSpeed">Knots</div>
          </div>
        </div>
      </div>
      <div class="setting-option">
        <div class="setting-o-text">PRESSURE</div>
        <div class="toggle-container">
          <div class="toggle pressure">
            <div class="toggle-el ${this._data.userSettings.pressure === "inches" ? "toggle-el--active" : ""} pressure-in" data-setting="pressure">Inches</div>
            <div class="toggle-el ${this._data.userSettings.pressure === "mb" ? "toggle-el--active" : ""} pressure-mb" data-setting="pressure">mb</div>
            <div class="toggle-el ${this._data.userSettings.pressure === "mm" ? "toggle-el--active" : ""} pressure-mm" data-setting="pressure">mm</div>
          </div>
        </div>
      </div>
      <div class="setting-option">
        <div class="setting-o-text">PRECIPITATION</div>
        <div class="toggle-container">
          <div class="toggle precipitation">
            <div class="toggle-el ${this._data.userSettings.precipitation === "inches" ? "toggle-el--active" : ""} precipitation-in" data-setting="precipitation">Inches</div>
            <div class="toggle-el ${this._data.userSettings.precipitation === "millimiters" ? "toggle-el--active" : ""} precipitation-mm" data-setting="precipitation">Millimiters</div>
          </div>
        </div>
      </div>
          <div class="setting-option">
        <div class="setting-o-text">DISTANCE</div>
        <div class="toggle-container">
          <div class="toggle distance">
            <div class="toggle-el ${this._data.userSettings.distance === "kilometers" ? "toggle-el--active" : ""} distance-km" data-setting="distance">Kilometers</div>
            <div class="toggle-el ${this._data.userSettings.distance === "miles" ? "toggle-el--active" : ""} distance-miles" data-setting="distance">Miles</div>
          </div>
        </div>
      </div>
    </div>
    `;
        this._container.insertAdjacentHTML("beforeend", html);
        const generalhtml = `
    <div class="setting-text general">General</div>
    <div class="general-settings">
      <div class="general-option t-f-hours">
        <div class="general-row">
          <p class="general-text ">24-Hour Time</p>
          <div class="toggle-switch-container">
            <input type="checkbox" class="toggle-switch" ${this._data.generalSettings.TFhours ? "checked" : ""} data-general="TFhours">
          </div>
        </div>
      </div>
      <div class="general-option location">
        <div class="general-row">
          <p class="general-text">Location</p>
          <div class="toggle-switch-container">
            <input type="checkbox" class="toggle-switch" ${this._data.generalSettings.location ? "checked" : ""} data-general="location">
          </div>
        </div>
        <div class="general-row row-small">
          <p class="general-desc">Get weather of your location</p>
        </div>
      </div>
      <div class="general-option notifications">
        <div class="general-row">
          <p class="general-text ">Notifications</p>
          <div class="toggle-switch-container">
            <input type="checkbox" class="toggle-switch" ${this._data.generalSettings.notifications ? "checked" : ""} data-general="notifications">
          </div>
        </div>
        <div class="general-row row-small">
          <p class="general-desc">Be aware of the weather</p>
        </div>
      </div>
    </div>
    
    <div class="sign-up-container">
      <div class="sign-up-header">Never forget your umbrella!</div>
      <div class="sign-up-text-btn">
        <div class="s-u-text">Sign up for our daily weather newsletter personalized just for you</div>
        <ul class="s-u-list">
            <li class="s-u-item">Severe weather notifications</li>
            <li class="s-u-item">Health activities overview</li>
        </ul>
        <button class="sign-up">Sign up</button>
      </div>
    </div>
    `;
        this._generalContainer.insertAdjacentHTML("beforeend", generalhtml);
    }
}
var $4c22adf96f0377b2$export$2e2bcd8739ae039 = new $4c22adf96f0377b2$var$SettingsView();





class $48c7f8798945c850$var$CitiesView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _nav = document.querySelector("nav");
    _navElement = document.querySelector(".n-item-2");
    _parentElement = document.querySelector(".cities-container");
    _contentElement = document.querySelector(".content");
    target;
    pageResult;
    insertCities() {
        if (Object.keys(this._data).length === 0) return;
        const html = this._generateMarkup();
        if (html === undefined) return;
        this._clear();
        this._reviveCities();
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    }
    _generateMarkup() {
        let html = "";
        if (Object.keys(this.pageResult).length === 0) return;
        for (const [city, weather] of Object.entries(this.pageResult))html += this._generateSavedCity(weather);
        return html;
    }
    addHandlerClick(callback) {
        this._nav.addEventListener("click", (e)=>{
            const target = e.target.closest(".n-item-2");
            if (!target) return;
            callback();
        });
    }
    addHandlerCity(callback) {
        this._parentElement.addEventListener("click", (e)=>{
            const target = e.target.closest(".city-saved");
            if (!target) return;
            this._toggleActive(target);
            this.target = target.querySelector(".city-saved-name span").textContent;
            callback();
        });
    }
    _toggleActive(target) {
        const arr = Array.from(document.querySelectorAll(".city-saved"));
        arr.forEach((el)=>el.classList.remove("city--active"));
        target.classList.add("city--active");
    }
    clearContainer() {
        if (!document.querySelector(".cities-wrapper")) return;
        const citiesCont = [
            document.querySelector(".cities-wrapper"),
            document.querySelector(".preview")
        ];
        this._makeInvisible(citiesCont);
    }
    _reviveCities() {
        const citiesCont = [
            document.querySelector(".cities-wrapper"),
            document.querySelector(".preview")
        ];
        this._makeVisible(citiesCont);
    }
    enableResponsive() {
        this._contentElement.classList.add("content__cities--responsive");
    }
    disableResponsive() {
        this._contentElement.classList.remove("content__cities--responsive");
    }
    _generateSavedCity(city) {
        return `
     <div class="city-saved ${city.location.name === this._data.activeCity ? "city--active" : ""}">
      <div class="city-img">
        <img src="${this._allImports[city.img]}">
      </div>
      <div class="city-name-time">
        <div class="city-saved-name"><span>${city.location.name}</span>${city.locale ? ` <svg width="17px" height="17px" viewBox="0 0 100 100"> <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#icon-arrow-location"> </use> </svg>` : ""}</div>
        <div class="city-saved-time">
        ${this._data.generalSettings.TFhours ? `${(0, $bd02c871d9c5ba8e$export$195ec01c71927300)(city.location.localtime)}` : `${(0, $bd02c871d9c5ba8e$export$fc1bebb0106af159)((0, $bd02c871d9c5ba8e$export$195ec01c71927300)(city.location.localtime)).slice(1)}`} 
        </div>
      </div>
      <div class="city-saved-temp">
        ${this._data.userSettings.temperature === "celsius" ? `${Math.round(city.current.feelslike_c)}` : `${Math.round(city.current.feelslike_f)}`}
        °
      </div>
    </div>
    `;
    }
}
var $48c7f8798945c850$export$2e2bcd8739ae039 = new $48c7f8798945c850$var$CitiesView();





class $7c473b79f8b11b95$var$DetailSectionView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _nav = document.querySelector("nav");
    _navElement = document.querySelector(".n-item-3");
    _parentElement = document.querySelector(".details-section-wrapper");
    _wrapperElement = document.querySelector(".content");
    addHandlerClick(callback) {
        this._nav.addEventListener("click", (e)=>{
            const target = e.target.closest(".n-item-3");
            if (!target) return;
            callback();
        });
    }
    clearDetailsContainer() {
        this._makeInvisible([
            this._parentElement
        ]);
    }
    reviveContainer() {
        this._makeVisible([
            this._parentElement
        ]);
    }
    insertDetails() {
        if (Object.keys(this._data).length === 0) return;
        const html = this._generateMarkup();
        this._clear();
        this._makeVisible([
            this._parentElement
        ]);
        this._parentElement.insertAdjacentHTML("beforeend", html);
    }
    enableResponsive() {
        this._wrapperElement.classList.add("content--responsive");
    }
    disableResponsive() {
        this._wrapperElement.classList.remove("content--responsive");
    }
    _generateMarkup() {
        return `
    <div class="air-quality-section">
      <div class="d-s-text">Air quality</div>
      <div class="air-quality">
       <div class="details-item">
        <div class="d-icon-text">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#pm-2">
          </svg>
          <p class="d-i-text">Particle Matter 2.5</p>
        </div> 
        <div class="d-i-value">${Math.round(this._data.current.air_quality.pm2_5)} µg/m³</div>
       </div>
       <div class="details-item">
        <div class="d-icon-text">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#pm-10">
          </svg>
          <p class="d-i-text">Particle Matter 10</p>
        </div> 
        <div class="d-i-value">${Math.round(this._data.current.air_quality.pm10)} µg/m³</div>
       </div>
       <div class="details-item">
          <div class="d-icon-text">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#no2">
          </svg>
          <p class="d-i-text">Nitrogen dioxide</p>
        </div> 
        <div class="d-i-value">${Math.round(this._data.current.air_quality.no2)} ppb</div>
       </div>
       <div class="details-item">
        <div class="d-icon-text">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#co">
          </svg>
          <p class="d-i-text">Carbon Monoxide</p>
        </div> 
        <div class="d-i-value">${Math.round(this._data.current.air_quality.co)} ppm</div>
       </div>
       <div class="details-item">
        <div class="d-icon-text">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#o3">
          </svg>
          <p class="d-i-text">Ozone</p>
        </div> 
        <div class="d-i-value">${Math.round(this._data.current.air_quality.o3)} ppb</div>
       </div>
       <div class="details-item">
        <div class="d-icon-text">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#so2">
          </svg>
          <p class="d-i-text">Sulfur Dioxide</p>
        </div> 
        <div class="d-i-value">${Math.round(this._data.current.air_quality.so2)} ppb</div>
       </div>
      </div>
    </div>
    <div class="other-details-section">
      <div class="d-s-text">Miscellaneous details</div>
      <div class="other-details">
        <div class="details-item">
          <div class="d-icon-text">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#humidity">
            </svg>
            <p class="d-i-text">Humidity</p>
          </div> 
          <div class="d-i-value">${this._data.current.humidity}%</div>
        </div>
        <div class="details-item">
          <div class="d-icon-text">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#precipitation">
            </svg>
            <p class="d-i-text">Precipitation</p>
          </div> 
          <div class="d-i-value">
          ${this._data.userSettings.precipitation === "millimiters" ? `${Math.round(this._data.current.precip_mm)} mm` : `${Math.round(this._data.current.precip_in)} in`}</div>
        </div>
        <div class="details-item">
          <div class="d-icon-text">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#pressure">
            </svg>
            <p class="d-i-text">Pressure</p>
          </div> 
          <div class="d-i-value">
          ${this._data.userSettings.pressure === "mb" ? `${this._data.current.pressure_mb} mb` : `${this._data.userSettings.pressure === "inches" ? `${Math.round(this._data.current.pressure_in)} in` : `${Math.round(this._data.current.pressure_in * 25.4)} mm`} `}</div>
        </div>
        <div class="details-item">
          <div class="d-icon-text">
            <svg viewBox="-100 0 605.394 605.395">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#thermometer">
            </svg>
            <p class="d-i-text">Temperature</p>
          </div> 
          <div class="d-i-value">
          ${this._data.userSettings.temperature === "celsius" ? `${Math.round(this._data.current.temp_c)}` : `${Math.round(this._data.current.temp_f)}`}°</div>
        </div>
        <div class="details-item">
          <div class="d-icon-text">
            <svg viewBox="-100 0 605.394 605.395">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#thermometer">
            </svg>
            <p class="d-i-text">Feels Like</p>
          </div> 
          <div class="d-i-value">${this._data.userSettings.temperature === "celsius" ? `${Math.round(this._data.current.feelslike_c)}` : `${Math.round(this._data.current.feelslike_f)}`}°</div>
        </div>
        <div class="details-item">
          <div class="d-icon-text">
            <svg viewBox="-50 0 300.564 300.564" id="not-svg">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#water">
            </svg>
            <p class="d-i-text">Chance of rain</p>
          </div> 
          <div class="d-i-value">${this._data.forecast.forecastday[0].day.daily_chance_of_rain}%</div>
        </div>
        <div class="details-item">
          <div class="d-icon-text">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#sunrise">
            </svg>
            <p class="d-i-text">Sunrise</p>
          </div> 
          <div class="d-i-value">${this._data.generalSettings.TFhours ? `${(0, $bd02c871d9c5ba8e$export$b405e4ac657f26ad)(this._data.forecast.forecastday[0].astro.sunrise)}` : `${this._data.forecast.forecastday[0].astro.sunrise.slice(1)}`}</div>
        </div>
        <div class="details-item">
          <div class="d-icon-text">
            <svg viewBox="-1.147 -22.185 141.732 141.732">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#cloud-sun">
            </svg>
            <p class="d-i-text">Sunset</p>
          </div> 
          <div class="d-i-value">${this._data.generalSettings.TFhours ? `${(0, $bd02c871d9c5ba8e$export$b405e4ac657f26ad)(this._data.forecast.forecastday[0].astro.sunset)}` : `${this._data.forecast.forecastday[0].astro.sunset.slice(1)}`}</div>
        </div>
        <div class="details-item">
          <div class="d-icon-text">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports))}#moorise">
            </svg>
            <p class="d-i-text">Moonrise</p>
          </div> 
          <div class="d-i-value">${this._data.generalSettings.TFhours ? `${(0, $bd02c871d9c5ba8e$export$b405e4ac657f26ad)(this._data.forecast.forecastday[0].astro.moonrise)}` : `${this._data.forecast.forecastday[0].astro.moonrise.slice(1)}`}</div>
        </div>
      </div>
    </div>
    `;
    }
}
const $7c473b79f8b11b95$var$svg = `    <svg>
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports)))}#pm-2">
    </svg>
    <svg>
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports)))}#pm-10">
    </svg>
    <svg>
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports)))}#no2">
    </svg>
    <svg>
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports)))}#co">
    </svg>
    <svg>
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports)))}#o3">
    </svg>
    <svg>
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($13931f3f82e1b378$exports)))}#so2">
    </svg>`;
const $7c473b79f8b11b95$var$other = `1: humidity, precipitaion, pressure, 
2: temp, real feel, chance of rain
3: sunset, sunrise, moonrise`;
var $7c473b79f8b11b95$export$2e2bcd8739ae039 = new $7c473b79f8b11b95$var$DetailSectionView();




class $a68ceb92eae160df$var$PreviewView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".preview");
    insertPreview() {
        if (Object.keys(this._data).length === 0) return;
        const html = this._generateMarkup();
        this._clear();
        this._parentElement.insertAdjacentHTML("beforeend", html);
    }
    clearPreviewContainer() {
        this._makeInvisible([
            this._parentElement
        ]);
    }
    revivePreview() {
        this._makeVisible([
            this._parentElement
        ]);
    }
    _generateHourly(hour, i) {
        if (i > 2) return;
        return `<li class="p-h-item">
            <div class="h-item-time">${this._data.generalSettings.TFhours ? `${new Date(hour.time).getHours()}:00` : `${(0, $bd02c871d9c5ba8e$export$fc1bebb0106af159)(`${new Date(hour.time).getHours()}:00`).slice(1)}`}</div>
            <div class="h-item-img">
              <img src="${this._allImports[hour.img]}" alt="weather condition">
            </div>
            <div class="h-item-temp">${this._data.userSettings.temperature === "celsius" ? `${Math.round(hour.feelslike_c)}` : `${Math.round(hour.feelslike_f)}`}°</div>
          </li>`;
    }
    _generateForecast(day, i) {
        if (i > 2) return;
        const weekDay = this._data.weekdays[new Date(day.date).getDay()];
        return `
    <li class="forecast-item">
            <p class="regular-light-text">${i > 0 ? weekDay : "Today"}</p>
            <div class="forecast-img-cond">
              <div class="forecast-img">
                <img src="${this._allImports[day.img]}">
              </div>
              <div class="forecast-cond">${day.dominantCondition}</div>
            </div>
            <div class="forecast-temp">
              <p class="bold-light-text"> ${this._data.userSettings.temperature === "celsius" ? `${Math.round(day.day.maxtemp_c)}` : `${Math.round(day.day.maxtemp_f)}`}</p>
              <p class="regular-light-text">/${this._data.userSettings.temperature === "celsius" ? `${Math.round(day.day.mintemp_c)}` : `${Math.round(day.day.mintemp_f)}`}</p>
            </div>
          </li>
          `;
    }
    _generateMarkup() {
        return `
         <div class="preview-city">
        <div class="p-c-text">
          <p class="p-city-name">${this._data.location.name}</p>
          <p class="p-rain-chance">Chance of rain: ${this._data.forecast.forecastday[0].day.daily_chance_of_rain}%</p>
          <p class="p-city-temp">${this._data.userSettings.temperature === "celsius" ? `${Math.round(this._data.current.feelslike_c)}` : `${Math.round(this._data.current.feelslike_f)}`}°</p>
        </div>
        <div class="p-c-img">
          <img src="${this._getSrc()}">
        </div>
      </div>
      <div class="preview-hourly">
        <div class="p-hourly-text">TODAY'S FORECAST</div>
        <ul class="p-hourly-content">
          ${this._data.hourly.map((hour, i)=>{
            return this._generateHourly(hour, i);
        }).join("")}
        </ul>
      </div>
      <div class="preview-forecast">
        <div class="forecast-text">3-DAY FORECAST</div>
        <ul class="forecast-list">
            ${this._data.forecast.forecastday.map((day, i)=>this._generateForecast(day, i)).join("")}
        </ul>
      </div>`;
    }
}
var $a68ceb92eae160df$export$2e2bcd8739ae039 = new $a68ceb92eae160df$var$PreviewView();



class $cfa940594ee109f7$var$PaginationView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".pagination");
    insertPagination() {
        if (Object.keys(this._data).length === 0) return;
        const html = this._generateMarkup();
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", html);
    }
    addHandlerPagination(callback) {
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".btn-page");
            if (!btn) return;
            if (btn.dataset.goto === "undefined") return;
            const goToPage = +btn.dataset.goto;
            callback(goToPage);
        });
    }
    _generateMarkup() {
        const numPages = Math.ceil(Object.keys(this._data.savedCities).length / this._data.citiesPerPage);
        const curPage = this._data.page;
        // Page 1 and other pages
        if (curPage === 1 && numPages > 1) return `<button data-goto="undefined" class="btn-page btn-disabled">Page ?</button>
            <span class="current-page">Page ${curPage}/${numPages}</span>
            <button data-goto="${curPage + 1}" class="btn-page">Page ${curPage + 1}</button>`;
        // Last page
        if (curPage === numPages && numPages > 1) return `
            <button data-goto="${curPage - 1}" class="btn-page ">Page ${curPage - 1}</button>
            <span class="current-page">Page ${curPage}/${numPages}</span>
            <button data-goto="undefined" class="btn-page btn-disabled">Page ?</button>
        `;
        // Other page
        if (curPage < numPages) return `<button data-goto="${curPage - 1}" class="btn-page">Page ${curPage - 1}</button>
            <span class="current-page">Page ${curPage}/${numPages}</span>
            <button data-goto="${curPage + 1}" class="btn-page">Page ${curPage + 1}</button>`;
        // Page 1 and no other pages
        return `<button data-goto="undefined" class="btn-page btn-disabled">Page ?</button>
            <span class="current-page">Page ${curPage}/${numPages}</span>
            <button data-goto="undefined" class="btn-page btn-disabled">Page ?</button>`;
    }
}
var $cfa940594ee109f7$export$2e2bcd8739ae039 = new $cfa940594ee109f7$var$PaginationView();



const $f50bd1f2915ed0f2$var$navElements = [
    (0, $6be7010d7cd51383$export$2e2bcd8739ae039),
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039),
    (0, $48c7f8798945c850$export$2e2bcd8739ae039),
    (0, $7c473b79f8b11b95$export$2e2bcd8739ae039)
];
const $f50bd1f2915ed0f2$var$controlShowWeather = async function(city) {
    try {
        if (typeof city === "object") {
            city = await $0f1d4402dffacf5b$export$e7fd20fad3cf4b5f();
            if (!city) city = "Zhytomyr";
        }
        // Render loading animation
        $f50bd1f2915ed0f2$var$controlLoadAnimation();
        // Disable nav buttons
        (0, $6be7010d7cd51383$export$2e2bcd8739ae039).toggleOverlay();
        // load weather data from the model
        await $0f1d4402dffacf5b$export$a7a8d53ca6ad3a0(city);
        await $0f1d4402dffacf5b$export$4569ca64384f677(city);
        await $0f1d4402dffacf5b$export$88cc774c1a6959f6();
        // Render Data for each element
        (0, $4cfee55aef1e3a92$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
        (0, $5c976a6fb1a25bc1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
        (0, $c34a89588b91ccbd$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
        (0, $e1b37a066ab13ba6$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
        (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
        (0, $48c7f8798945c850$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
        (0, $a68ceb92eae160df$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
        (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
        // Insert city data
        (0, $e1b37a066ab13ba6$export$2e2bcd8739ae039).insertCity();
        // Insert hourly data
        (0, $5c976a6fb1a25bc1$export$2e2bcd8739ae039).insertHourly();
        // Insert details data
        (0, $c34a89588b91ccbd$export$2e2bcd8739ae039).insertDetails();
        // Insert seven day forecast data
        (0, $4cfee55aef1e3a92$export$2e2bcd8739ae039).insertDays();
        // Enable overlay
        (0, $6be7010d7cd51383$export$2e2bcd8739ae039).toggleOverlay();
    } catch (err) {
        console.error(err);
        (0, $e1b37a066ab13ba6$export$2e2bcd8739ae039).renderError("Failed to fetch");
        $f50bd1f2915ed0f2$var$controlLoadAnimation(true);
        (0, $6be7010d7cd51383$export$2e2bcd8739ae039).toggleOverlay();
        // Reload the page by force after 2s
        (0, $bd02c871d9c5ba8e$export$f39dd77216918a27)();
    }
};
const $f50bd1f2915ed0f2$var$controlLoadAnimation = function(error = false) {
    (0, $4cfee55aef1e3a92$export$2e2bcd8739ae039).renderLoading();
    (0, $5c976a6fb1a25bc1$export$2e2bcd8739ae039).renderLoading();
    (0, $c34a89588b91ccbd$export$2e2bcd8739ae039).renderLoading();
    if (!error) (0, $e1b37a066ab13ba6$export$2e2bcd8739ae039).renderSpinner();
};
const $f50bd1f2915ed0f2$var$controlSearchResult = function() {
    const query = (0, $813cf99795e9ec97$export$2e2bcd8739ae039).getQuery();
    if (!query) return;
    $f50bd1f2915ed0f2$var$controlShowWeather(query);
    $f50bd1f2915ed0f2$var$controlLanding(false);
};
const $f50bd1f2915ed0f2$var$controlLanding = function(update = true) {
    (0, $6be7010d7cd51383$export$2e2bcd8739ae039).enableActive();
    $f50bd1f2915ed0f2$var$controlActiveElement((0, $6be7010d7cd51383$export$2e2bcd8739ae039));
    (0, $6be7010d7cd51383$export$2e2bcd8739ae039).reviveContentContainer();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).clearSettingsContainer();
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).clearContainer();
    (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).clearDetailsContainer();
    (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).disableResponsive();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).disableResponsive();
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).disableResponsive();
    // Update DOM components
    if (!update) return;
    (0, $e1b37a066ab13ba6$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e);
    (0, $c34a89588b91ccbd$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e);
    (0, $5c976a6fb1a25bc1$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e);
    (0, $4cfee55aef1e3a92$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e);
};
const $f50bd1f2915ed0f2$var$controlSettings = function() {
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).enableActive();
    $f50bd1f2915ed0f2$var$controlActiveElement((0, $4c22adf96f0377b2$export$2e2bcd8739ae039));
    (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).disableResponsive();
    (0, $6be7010d7cd51383$export$2e2bcd8739ae039).clearContentContainer();
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).clearContainer();
    (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).clearDetailsContainer();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).insertElements();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).enableResponsive();
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).disableResponsive();
};
const $f50bd1f2915ed0f2$var$controlSettingsOption = function(target) {
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).toggleActive($0f1d4402dffacf5b$export$8e034fe27ea783b9(target));
};
const $f50bd1f2915ed0f2$var$controlGeneralSettings = function(target) {
    $0f1d4402dffacf5b$export$1609e83cd44a6870(target);
};
const $f50bd1f2915ed0f2$var$controlCities = function() {
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).enableActive();
    $f50bd1f2915ed0f2$var$controlActiveElement((0, $48c7f8798945c850$export$2e2bcd8739ae039));
    (0, $6be7010d7cd51383$export$2e2bcd8739ae039).clearContentContainer();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).clearSettingsContainer();
    (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).clearDetailsContainer();
    const results = $0f1d4402dffacf5b$export$52e4c50a43f85078($0f1d4402dffacf5b$export$ca000e230c0caa3e.page);
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).insertPagination();
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).pageResult = results;
    if (!document.querySelector(".city-saved")) {
        (0, $48c7f8798945c850$export$2e2bcd8739ae039).insertCities();
        (0, $48c7f8798945c850$export$2e2bcd8739ae039)._reviveCities();
    } else (0, $48c7f8798945c850$export$2e2bcd8739ae039)._reviveCities();
    if (!document.querySelector(".preview-city")) (0, $a68ceb92eae160df$export$2e2bcd8739ae039).insertPreview();
    (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).disableResponsive();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).disableResponsive();
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).enableResponsive();
    //Update preview
    (0, $a68ceb92eae160df$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e);
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e);
};
const $f50bd1f2915ed0f2$var$controlActiveCities = async function() {
    const city = (0, $48c7f8798945c850$export$2e2bcd8739ae039).target;
    if (!city) return;
    await $f50bd1f2915ed0f2$var$controlShowWeather(city);
    (0, $a68ceb92eae160df$export$2e2bcd8739ae039).insertPreview();
};
const $f50bd1f2915ed0f2$var$controlPagination = function(page) {
    const results = $0f1d4402dffacf5b$export$52e4c50a43f85078(page);
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).pageResult = results;
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).insertCities();
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.page = page;
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).insertPagination();
};
const $f50bd1f2915ed0f2$var$controlDetails = function() {
    (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).enableActive();
    $f50bd1f2915ed0f2$var$controlActiveElement((0, $7c473b79f8b11b95$export$2e2bcd8739ae039));
    // Clear the page
    (0, $6be7010d7cd51383$export$2e2bcd8739ae039).clearContentContainer();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).clearSettingsContainer();
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).clearContainer();
    if (!document.querySelector(".air-quality-section")) (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).insertDetails();
    else (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).reviveContainer();
    // Insert components
    if (!document.querySelector(".preview-city")) (0, $a68ceb92eae160df$export$2e2bcd8739ae039).insertPreview();
    (0, $a68ceb92eae160df$export$2e2bcd8739ae039).revivePreview();
    (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).enableResponsive();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).disableResponsive();
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).disableResponsive();
    (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e);
    (0, $a68ceb92eae160df$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e);
};
const $f50bd1f2915ed0f2$var$controlActiveElement = function(enabled) {
    $f50bd1f2915ed0f2$var$navElements.forEach((el)=>{
        if (el === enabled) return;
        el.disableActive();
    });
};
const $f50bd1f2915ed0f2$var$controlSavedCity = function(btn) {
    if (Object.keys($0f1d4402dffacf5b$export$ca000e230c0caa3e.savedCities).includes($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeCity)) $0f1d4402dffacf5b$export$6e8d81316029aa6d($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeCity);
    else $0f1d4402dffacf5b$export$8727201a1c9728f4($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeCity);
    (0, $e1b37a066ab13ba6$export$2e2bcd8739ae039).toggleAnimation(btn);
    (0, $e1b37a066ab13ba6$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e);
    // cityView.render(model.state);
    // cityView.insertCity();
    let results = $0f1d4402dffacf5b$export$52e4c50a43f85078($0f1d4402dffacf5b$export$ca000e230c0caa3e.page);
    if (Object.keys(results).length === 0 && $0f1d4402dffacf5b$export$ca000e230c0caa3e.page > 1) {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.page--;
        results = $0f1d4402dffacf5b$export$52e4c50a43f85078($0f1d4402dffacf5b$export$ca000e230c0caa3e.page);
    }
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).pageResult = results;
    (0, $48c7f8798945c850$export$2e2bcd8739ae039)._clear();
};
const $f50bd1f2915ed0f2$var$init = function() {
    (0, $6be7010d7cd51383$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlShowWeather);
    (0, $813cf99795e9ec97$export$2e2bcd8739ae039).addHandlerSearch($f50bd1f2915ed0f2$var$controlSearchResult);
    (0, $6be7010d7cd51383$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlLanding);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlSettings);
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlCities);
    (0, $7c473b79f8b11b95$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlDetails);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).addHandlerSettings($f50bd1f2915ed0f2$var$controlSettingsOption);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).addHandlerGeneralSettings($f50bd1f2915ed0f2$var$controlGeneralSettings);
    (0, $48c7f8798945c850$export$2e2bcd8739ae039).addHandlerCity($f50bd1f2915ed0f2$var$controlActiveCities);
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).addHandlerPagination($f50bd1f2915ed0f2$var$controlPagination);
    (0, $e1b37a066ab13ba6$export$2e2bcd8739ae039).addHandlerSave($f50bd1f2915ed0f2$var$controlSavedCity);
    (0, $6be7010d7cd51383$export$2e2bcd8739ae039).addHandlerSeeMore($f50bd1f2915ed0f2$var$controlDetails);
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.9785fd68.js.map
